import api from 'Api'
import { SET_MESSAGE } from '../components/utils'

const state = {
  customers: [
    {
      entity_id: 1,
      name: 'Vendors.db 1',
      desc: 'Indiana University Health, formerly known as Clarian Health Partners, is a nonprofit haelthcare located in the US state of Indiana.',
      type: 'Direct',
      revenue_band: '>500M USD',
      owner: 'Reuben Vandeverter',
      employees: '>3000',
      account_settings: 'Trial Period',
      img: require('@/assets/icons/sql-server.png')
    },
    {
      entity_id: 2,
      name: 'Vendors.db 2',
      desc: 'Indiana University Health, formerly known as Clarian Health Partners, is a nonprofit haelthcare located in the US state of Indiana.',
      type: 'Direct',
      revenue_band: '>500M USD',
      owner: 'Reuben Vandeverter',
      employees: '>3000',
      account_settings: 'Trial Period',
      img: require('@/assets/icons/sql-server.png')
    },
    {
      entity_id: 3,
      name: 'Vendors.db 3',
      desc: 'Indiana University Health, formerly known as Clarian Health Partners, is a nonprofit haelthcare located in the US state of Indiana.',
      type: 'Direct',
      revenue_band: '>500M USD',
      owner: 'Reuben Vandeverter',
      employees: '>3000',
      account_settings: 'Trial Period',
      img: require('@/assets/icons/sql-server.png')
    },
    {
      entity_id: 4,
      name: 'Vendors.db 4',
      desc: 'Indiana University Health, formerly known as Clarian Health Partners, is a nonprofit haelthcare located in the US state of Indiana.',
      type: 'Direct',
      revenue_band: '>500M USD',
      owner: 'Reuben Vandeverter',
      employees: '>3000',
      account_settings: 'Trial Period',
      img: require('@/assets/icons/sql-server.png')
    }
  ],
  portalData: []
}

const getters = {
  customers: state => {
    return state.customers
  },
  portalData: state => {
    return state.portalData
  }
}

const actions = {
  async addPartnerCustomer (context, payload) {
    const { data } = await api().post('/partner-portal-user', {
      ...payload
    })
    if (data.error) throw Error(data.error)

    let currentParent = null
    for (let i = 0; i < context.state.portalData.length; i++) {
      findCurrentParent(context.state.portalData[i], payload.parent_id)
    }

    function findCurrentParent (element, matchingTitle) { // Find Parent Field
      if (element.id.indexOf(matchingTitle) > -1) {
        if (element) {
          currentParent = element
        }
      } else if (element.children) {
        let i
        let result = null
        for (i = 0; result === null && i < element.children.length; i++) {
          result = findCurrentParent(element.children[i], matchingTitle)
        }
        return result
      }
      return null
    }
    if (!payload.parent_id) { // Add first level Data
      context.state.portalData.push({
        id: data.id,
        name: payload.name,
        roleType: payload.role_id === 1 ? 'Partner' : 'Customer'
      })
    } else if (currentParent) { // Add sub list data
      if (!currentParent.children) currentParent.children = []
      currentParent.children.push({
        Parent: payload.parent_id,
        id: data.id,
        name: payload.name,
        roleType: payload.role_id === 1 ? 'Partner' : 'Customer'
      })
    }

    SET_MESSAGE({ type: 'success', message: (payload.role_id === 1 ? 'Partner ' : 'Customer ') + ' was successfully added!' })
  },
  async getAllPortals (context, payload) {
    try {
      const { data } = await api().get('/partner-portal-user/' + payload)
      context.commit('SET_PORTAL_DATA', data)
    } catch (error) {
      SET_MESSAGE({ type: 'error', message: error.response?.data?.error || error.message })
    }
  }
}

const mutations = {
  SET_PORTAL_DATA (context, payload) {
    context.portalData = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  name: 'partnerServices'
}
